// extracted by mini-css-extract-plugin
export default {"container":"style_container__typyL","loaderText":"style_loaderText__6OHQS"};